import { render } from "./RoleImpersonation.vue?vue&type=template&id=c835dd3e"
import script from "./RoleImpersonation.vue?vue&type=script&lang=js"
export * from "./RoleImpersonation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__